import React from 'react';
import PropTypes from 'prop-types';

const NoteIcon = ({ fill, ...props }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8121 2.23033C11.3561 0.756823 9.35639 -0.0500963 7.28647 0.00252884C3.16416 0.125321 -0.0635202 3.54596 0.0592719 7.66826C0.0768137 8.52781 0.252231 9.36981 0.567982 10.1592C0.831108 10.8258 1.18194 11.4397 1.62049 12.0011L1.00653 13.457C0.760941 14.0184 1.02407 14.6674 1.5854 14.913C1.77836 15.0007 2.0064 15.0182 2.21691 14.9832L5.05867 14.492C6.07609 14.8428 7.14613 14.9656 8.21618 14.8604C11.8824 14.492 14.7417 11.4924 14.9347 7.8086C15.0399 5.72113 14.2681 3.70383 12.8121 2.23033ZM6.95317 10.4223H5.00604C4.70783 10.4223 4.44471 10.1767 4.44471 9.86098C4.44471 9.56277 4.69029 9.29964 5.00604 9.29964H6.95317C7.25138 9.29964 7.51451 9.54523 7.51451 9.86098C7.51451 10.1767 7.26893 10.4223 6.95317 10.4223ZM9.98789 8.14189H5.00604C4.70783 8.14189 4.44471 7.89631 4.44471 7.58056C4.44471 7.2648 4.69029 7.01922 5.00604 7.01922H9.98789C10.2861 7.01922 10.5492 7.2648 10.5492 7.58056C10.5492 7.89631 10.2861 8.14189 9.98789 8.14189ZM9.98789 5.84392H5.00604C4.70783 5.84392 4.44471 5.59834 4.44471 5.28259C4.44471 4.98438 4.69029 4.72125 5.00604 4.72125H9.98789C10.2861 4.72125 10.5492 4.96684 10.5492 5.28259C10.5492 5.5808 10.2861 5.84392 9.98789 5.84392Z"
      fill={fill || '#2C2543'}
    />
  </svg>
);

NoteIcon.propTypes = {
  fill: PropTypes.string,
};

export default NoteIcon;
